"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var createRibbonViewState_1 = require("owa-editor-ribbonplugin/lib/utils/createRibbonViewState");
var createEditorViewState_1 = require("owa-editor/lib/utils/createEditorViewState");
var satcheljs_1 = require("satcheljs");
exports.default = satcheljs_1.createStore('signatureOption', {
    editorViewState: createEditorViewState_1.default(null /*content*/, false /*isDirty*/),
    ribbon: createRibbonViewState_1.default(),
    signNewMails: null,
    signReplies: null,
})();
//# sourceMappingURL=store.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-signature-option/lib/store/store.js
// module id = 2893
// module chunks = 2